import { Checkbox as ChakraCheckbox, CheckboxProps as ChakraCheckboxProps, forwardRef } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { selectLikeDefaultProps, selectLikePropTypes } from '_helpers';

export type CheckboxProps = ChakraCheckboxProps;

const propTypes = {
  ...selectLikePropTypes,
  isIndeterminate: PropTypes.bool
};

const defaultProps = {
  ...selectLikeDefaultProps,
  isIndeterminate: false
};

const Checkbox = forwardRef<CheckboxProps, 'input'>((props: CheckboxProps & typeof defaultProps, ref) => {
  return <ChakraCheckbox ref={ref} {...props} />;
});

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
Checkbox.displayName = 'Checkbox';

export default Checkbox;
